var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamondIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 23,
    viewBox: "0 0 29 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 0H6L0 6.00001L14.5 23L29 6.00001L23 0Z",
    fill: "#00C3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 0L14.5 23L29 6.00001L23 0Z",
    fill: "#87DAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 0L8.21765 6.00001H0L6 0Z",
    fill: "#00AAF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5011 0L8.21875 6.00001H20.7835L14.5011 0Z",
    fill: "#87DAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7812 6.00001H28.9989L22.9989 0L20.7812 6.00001Z",
    fill: "#A5E9FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6H8.21765L14.5 23L0 6Z",
    fill: "#0096DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondIcon);
export default __webpack_public_path__ + "static/media/diamond-icon.96bb908f00c570b0711b6ab5d0c63c78.svg";
export { ForwardRef as ReactComponent };